import React from 'react';
import {PriceBox} from '@/_application/modules/products/components/price/price-box';
import {ProductImage} from './image/product-image';
import {ProductRatingBox} from '@/_application/modules/products/components/ratings/product-rating-box';
import {getProductUrl, Product} from '@/_application/modules/products/model/product';
import Link from '@/_application/core/components/ui/link';
import {useProductBrand} from '@/framework/highlight-brands';
import {getRatingDataFromProduct} from '@/_application/helpers/product';

interface ProductItemSearchProps {
    isLastItem?: boolean;
    product: Product;
}

const ProductItemSearch: React.FC<ProductItemSearchProps> = ({product}) => {
    const {brand} = useProductBrand(product);

    return (
        <Link
            href={getProductUrl(product, false)}
            className="product-item my-2.5 flex cursor-pointer items-center gap-2 rounded-[10px] p-2.5 shadow-productCard transition-colors hover:bg-KPZ_Gray-06">
            <div className="h-[110px] w-[110px] shrink-0 rounded-[10px]! bg-white p-2">
                <ProductImage product={product} position="mini-search" />
            </div>

            <div className="flex flex-col gap-0.5">
                <p className="line-clamp-2 text-sm font-bold text-KPZ_text_1st">{product?.name}</p>

                {brand?.label && (
                    <p className="text-xs">
                        by <span className="italic text-KPZ_turquoise">{brand.label}</span>
                    </p>
                )}

                <PriceBox product={product} size="medium" />

                <div className="flex items-center gap-0.5">
                    <ProductRatingBox ratingData={getRatingDataFromProduct(product)} />
                </div>
            </div>
        </Link>
    );
};

export default ProductItemSearch;
